import { render, staticRenderFns } from "./paymentKeyManage.vue?vue&type=template&id=a37970bc"
import script from "./paymentKeyManage.vue?vue&type=script&lang=js"
export * from "./paymentKeyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports